import React from 'react'
import { Text } from '@chakra-ui/react'
import { useLocation, useNavigate } from 'react-router-dom'

export default function ErriLink({ children, to }) {
  const location = useLocation()
  const navigate = useNavigate()

  const openProduct = (productName) => {
    const encodedName = encodeURIComponent(productName)
    const pathParts = location.pathname.split('/').filter(Boolean) // split path

    let finalPath = ''

    if (pathParts[0] !== 'products') {
      // Case 1: not on products page
      finalPath = `/products/${encodedName}`
    } else if (pathParts.length === 1) {
      // Case 2: /products → add product name
      finalPath = `/products/${encodedName}`
    } else {
      // Case 3: /products/:productName → replace product name
      finalPath = `/products/${encodedName}`
    }

    navigate(finalPath)
  }


  const trackClick = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'click',
      event_category: 'Button',
      event_label: 'Erri Link',
      link_to: to,
    })
  }
  return (
    <Text cursor="pointer"
      onClick={() => {
        trackClick()
        openProduct(to)
      }}
    >
      {children}
    </Text>
  )
}
